import ErrorFeedback from 'Components/ErrorFeedback/ErrorFeedback'
import PageContainer from 'Components/PageContainer'
import { Loading, ToastContainer, Tooltip } from 'mailup-web-components'
import Header from 'Pages/DynamicContentList/components/Header'
import { getDynamicContentListCallback } from 'Pages/DynamicContentList/recoil/callbacks/callbacks'
import { pageState } from 'Pages/DynamicContentList/recoil/state/page'
import { useEffect } from 'react'
import { useRecoilCallback, useRecoilState } from 'recoil'
import SectionContents from './components/SectionContents'
import SectionIntegration from './components/SectionIntegration/SectionIntegration'

const DynamicContentList = () => {
  // const query = new URLSearchParams(useLocation().search)
  // const ws = query.get('ws')
  const [{ loading, loaded, error, severity }, setPageState] =
    useRecoilState(pageState)

  const initPage = useRecoilCallback(getDynamicContentListCallback, [])

  useEffect(() => {
    if (!loaded) {
      initPage({
        isFirstLoading: true
      })
    }
  }, [loaded])
  const reloadPage = () => {
    setPageState((prev) => ({
      ...prev,
      loaded: false
    }))
  }
  return (
    <>
      <Header />
      <Tooltip />
      <Loading open={loading} />
      <ToastContainer />
      <PageContainer className='c-dynamiccontentlist'>
        <ErrorFeedback
          error={error}
          severity={severity}
          onClickReload={reloadPage}
        />
        {!error && (
          <>
            <SectionContents />
            <SectionIntegration />
          </>
        )}
      </PageContainer>
    </>
  )
}

export default DynamicContentList
